export enum PeriodicityEnum {
  unit = 'unit', // Unitaire
  monthly = 'monthly', // Mensuelle
  quarterly = 'quarterly', // Trimestrielle
  halfYearly = 'half_yearly', // Semestrielle
  annual = 'annual' // Annuelle
}
